import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import SEOMeta from "@/components/base/SEOMeta";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedSection from "./components/FeaturedSection";
import ArticleList from "./components/ArticleList";
import StatsSection from "./components/StatsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import { faqs, siteInfo } from "@/mocks/site";

export default function Home() {
  return (
    <>
      <SEOMeta
        title={`${siteInfo.name} - ${siteInfo.tagline} | 蘑菇tv成品人专属频道`}
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl="https://mogutv.com/"
        ogTitle={`${siteInfo.name} - ${siteInfo.tagline}`}
        ogDescription={siteInfo.description}
        ogType="website"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: `${siteInfo.name} - 首页`,
            description: siteInfo.description,
            url: "https://mogutv.com/",
            inLanguage: "zh-CN",
            isPartOf: {
              "@type": "WebSite",
              name: siteInfo.name,
              url: "https://mogutv.com",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedSection />
          <StatsSection />
          <ArticleList />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}